import { render } from "./ListeReglementPage.vue?vue&type=template&id=87804dca&ts=true"
import script from "./ListeReglementPage.vue?vue&type=script&lang=ts"
export * from "./ListeReglementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__